import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getTestScheduleDetails } from 'modules/activityDetails/MarlinsEnglishTestDetails/api/marlinsEnglishTestDetailsService'
import { MarlinsEnglishTestDetailsState, ApiMarlinsEnglishTestDetailsResponse } from './types'

const initialState: MarlinsEnglishTestDetailsState = {
  scheduleDetailsData: {},
}

const marlinsEnglishTestDetailsSlice = createSlice({
  name: 'marlinsEnglishTestDetails',
  initialState,
  reducers: {
    scheduleDetailsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiMarlinsEnglishTestDetailsResponse>>
    ) {
      state.scheduleDetailsData = action.payload
    },
    clearScheduleDetails(state) {
      state.scheduleDetailsData = initialState.scheduleDetailsData
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => initialState)
  },
})

const { scheduleDetailsLoaded, clearScheduleDetails } = marlinsEnglishTestDetailsSlice.actions
export { clearScheduleDetails }
export default marlinsEnglishTestDetailsSlice.reducer

export const loadScheduleDetailsData = (scheduleId: string): ApiAction =>
  createApiAction({
    apiCalls: {
      scheduleDetails: () => getTestScheduleDetails(scheduleId),
    },
    payloadAction: scheduleDetailsLoaded,
  })

export const reloadScheduleDetailsData = (scheduleId: string): ApiAction =>
  createApiAction({
    apiCalls: {
      scheduleDetails: () => getTestScheduleDetails(scheduleId),
    },
    payloadAction: scheduleDetailsLoaded,
    shouldShowGlobalLoading: true,
    shouldCallApi: ({ marlinsEnglishTestDetails }) =>
      !marlinsEnglishTestDetails.scheduleDetailsData.isLoading,
    getResultToKeep: ({ marlinsEnglishTestDetails }) =>
      marlinsEnglishTestDetails.scheduleDetailsData.result,
  })
